"use client";

import { Content } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import * as S from "./index.styles";
import { PrismicNextImage } from "@prismicio/next";
import { useMediaQuery } from "usehooks-ts";
/**
 * Props for `Footer`.
 */
export type FooterProps = SliceComponentProps<Content.FooterSlice>;

/**
 * Component for "Footer" Slices.
 */
const Footer = ({ slice }: FooterProps): JSX.Element => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <S.FooterContainer
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <S.TopSection>
        {!isMobile && (
          <>
            <S.ImageContainer>
              <PrismicNextImage field={slice.primary.logo} alt="" />
              {slice.primary.cta && (
                <S.Button field={slice.primary.cta}>
                  {slice.primary.cta_text}
                </S.Button>
              )}
            </S.ImageContainer>
            <S.Divider />
          </>
        )}
        <div>
          <S.Contact>Contacto</S.Contact>
          <>{slice.primary.number}</>
          <PrismicRichText field={slice.primary.street} />
        </div>
      </S.TopSection>
      <PrismicRichText field={slice.primary.disclaimer} />
      {!isMobile && (
        <PrismicNextImage field={slice.primary.left_image} alt="" />
      )}
      {isMobile && slice.primary.cta && (
        <S.Button field={slice.primary.cta}>{slice.primary.cta_text}</S.Button>
      )}
    </S.FooterContainer>
  );
};

export default Footer;
